<template>
   <div>
      <h6 class="title-page--upper-title">{{upper_title}}</h6>
      <h1 class="title-page--title">{{title}}</h1>
   </div>
</template>

<script>
export default {
   props: ['upper_title','title'],
};
</script>

<style lang="scss" scoped>
/*  */
.title-page{
   &--upper-title{
      font-weight: 100;
      text-transform: uppercase;
   }
   &--title{
      font-weight: 700;
      text-transform: capitalize;
      color: $primary;
   }
}
</style>
